export default "__VITE_ASSET__IuI1yHHv__"